require("jquery-ui/ui/widgets/autocomplete");
$(function () {
  const dataList = function(request, response) {
    var value = $('#prefecture').val();
    if(!value) return;
    $.ajax({
      url: '/member_info/autocomplete_jichitai/' + request.term +'/'+ value,
      dataType: 'json',
      type: 'GET',
      cache: true,
      success: function(data) {
        response(data);
      }
    });
  };

  $('#jichitai').autocomplete({
    source: dataList,
    autoFocus: true, 
    delay: 300, 
    minLength: 1 
  });
});